<div class="overlay">
  <div class="suspend-popup">
    <img src="assets/img/settings/suspended.svg" width="37px" height="37px">
    <h1>Account Suspended</h1>
    <p>This account has been suspended. <br>
      Visit <a class="link" (click)="goToSupport()">our Support</a> for more information.</p>

    <button class="landing-button" (click)="logout()">LOG OUT</button>
  </div>
</div>
